import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { PageLayout } from '../components/organisms/PageLayout';
import '../styles/not-found.css';

const NotFound: React.FC = () => {
  const { userProfile, isLoading } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'OfferFlow | Page Not Found';
  }, []);

  const handleGoHome = () => {
    navigate('/welcome', { replace: true });
  };

  const handleGoSignIn = () => {
    navigate('/sign-in', { replace: true });
  };

  if (isLoading) {
    return null;
  }

  if (userProfile) {
    const breadcrumbItems = [
      { label: 'Home', href: '/' },
      { label: 'Page not found' },
    ];

    return (
      <PageLayout breadcrumbItems={breadcrumbItems}>
        <div className="not-found">
          <div className="not-found__card">
            <h1 className="not-found__title">Page not found</h1>
            <p className="not-found__text">
              The page you are looking for doesn&apos;t exist or may have been moved.
            </p>
            <button className="not-found__button" onClick={handleGoHome}>
              Go to Welcome
            </button>
          </div>
        </div>
      </PageLayout>
    );
  }

  return (
    <div className="not-found not-found--unauth">
      <div className="not-found__card">
        <h1 className="not-found__title">Page not found</h1>
        <p className="not-found__text">
          The page you are looking for doesn&apos;t exist. You may need to sign in to access the app.
        </p>
        <button className="not-found__button" onClick={handleGoSignIn}>
          Go to Sign In
        </button>
      </div>
    </div>
  );
};

export default NotFound;


